<script lang="ts">
import type { Post } from '~/models/blog';

type Props = {
  post: Post;
};
</script>

<script setup lang="ts">
const props = defineProps<Props>();
const { t } = useI18n();

const link = `https://magazin.portu.cz/${props.post.slug}`;
const anchorTitle = t('homepage.blog.aria-read-article', {
  title: props.post.title.rendered,
});
const image = computed(() => {
  if (
    !props.post._embedded['wp:featuredmedia'] ||
    props.post._embedded['wp:featuredmedia'].length === 0
  ) {
    return '';
  }

  return props.post._embedded['wp:featuredmedia'][0].source_url;
});
const excerpt = props.post.excerpt.rendered.replace('<p>', '').replace('</p>', '');
</script>

<template>
  <div class="post">
    <div class="post__image" :style="`--img: url(${image})`"></div>
    <div class="post__container">
      <h4 v-html="post.title.rendered" />

      <div>
        <span>{{ excerpt }}</span>
      </div>

      <Button
        variant="outlined"
        theme="light"
        as="a"
        target="_blank"
        rel="nofollow"
        :to="link"
        :title="anchorTitle"
      >
        {{ $t('homepage.blog.read-article') }}
      </Button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
/* some values are used in SkeletonArticleCard */
.post {
  display: flex;
  flex-direction: column;

  height: 100%;

  background: var(--brown-lightest);
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 0.75rem;

  overflow: hidden;

  color: var(--black);

  &:hover {
    background-color: var(--white);
  }
}

.post__image {
  width: 100%;
  height: 12.5rem;

  background-image: var(--img);
  background-position: center;
  background-size: cover;
}

.post__container {
  display: flex;
  flex-direction: column;
  flex: 1;

  padding: 1.25rem 1.25rem 1.875rem 1.25rem;

  h4 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;

    margin-bottom: 1.25rem;

    width: 100%;
    min-height: calc(var(--font-size-lg) * 3.6);

    overflow: hidden;
  }

  div {
    flex-grow: 1;
  }

  span {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;

    overflow: hidden;
  }
}

.button {
  margin-top: 1.25rem;

  text-align: center;
  justify-content: center;
}
</style>
